import { GET_ALL_FILTER_TYPES_QUERY } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/FilterChirpService.dfc.new';
import { useGetAllFilterTypesQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/FilterChirpService.hooks';
import { dataFetchingClient } from '../../utils/DataFetchingClient';
import { Set as ImmutableSet } from 'immutable';
import { useMemo } from 'react';
export const getFilters = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_ALL_FILTER_TYPES_QUERY
  });
};
export const useFilters = () => {
  const {
    data: filters,
    loading: filtersLoading,
    error: filtersError
  } = useGetAllFilterTypesQuery();
  return {
    filters,
    filtersLoading,
    filtersError
  };
};
export const useImmutableFilters = () => {
  const {
    filters: filtersResponse,
    filtersLoading,
    filtersError
  } = useFilters();
  const filters = useMemo(() => {
    var _filtersResponse$subC, _filtersResponse$hsSo, _filtersResponse$leve, _filtersResponse$useC, _filtersResponse$busi;
    return {
      subCategories: ImmutableSet((_filtersResponse$subC = filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.subCategories) !== null && _filtersResponse$subC !== void 0 ? _filtersResponse$subC : []),
      hsSoftwareFilters: ImmutableSet((_filtersResponse$hsSo = filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.hsSoftwareFilters) !== null && _filtersResponse$hsSo !== void 0 ? _filtersResponse$hsSo : []),
      levelFilters: ImmutableSet((_filtersResponse$leve = filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.levelFilters) !== null && _filtersResponse$leve !== void 0 ? _filtersResponse$leve : []),
      useCaseFilters: ImmutableSet((_filtersResponse$useC = filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.useCaseFilters) !== null && _filtersResponse$useC !== void 0 ? _filtersResponse$useC : []),
      businessObjectiveFilters: ImmutableSet((_filtersResponse$busi = filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.businessObjectiveFilters) !== null && _filtersResponse$busi !== void 0 ? _filtersResponse$busi : [])
    };
  }, [filtersResponse]);
  return {
    filters,
    filtersLoading,
    filtersError
  };
};